<template>
  <div class="modal_wrap" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">견적 요청서</h1>
        </div>
        <div class="modal_con">
          <div class="request_table">
            <div class="request_date">{{ item.createdAt }}</div>
            <EstimationCard :item="item" />
            <div class="txt_box" v-if="isSendEstimateVisible">
              <!--견적요청 전-->
              <div class="txt" v-if="!item.requestedAt">
                나의 관심매장들에게<br />
                견적을 받아보시겠어요?
              </div>
              <div class="btn_wrap_area" v-if="!item.requestedAt">
                <div class="btn_wrap">
                  <button class="btn bo grey" v-on:click="$emit('close')">
                    아니오
                  </button>
                  <button class="btn" v-on:click="$emit('sendEstimate', item)">
                    네 (견적요청)
                  </button>
                </div>
              </div>
              <!--견적 마쳤을 때-->
              <div
                class="txt"
                style="padding-bottom: 0;"
                v-if="item.requestedAt"
              >
                주변매장들에게 견적을<br />
                요청한 건입니다.
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal_btn"
          v-if="!isSendEstimateVisible || item.requestedAt"
        >
          <div class="btn_wrap">
            <!--<button class="btn"></button>-->
            <button class="btn" v-on:click="$emit('close')">닫기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EstimationCard from '@/front/customer/views/estimation/components/EstimationCard';

export default {
  components: {
    EstimationCard,
  },
  name: 'EstimationDetailModal',
  data() {
    return {
      item: {},
      isSendEstimateVisible: false,
      isOpen: false,
    };
  },
};
</script>
